import { render, staticRenderFns } from "./rencana_kebutuhan_darah.vue?vue&type=template&id=645cf32a&scoped=true"
import script from "./rencana_kebutuhan_darah.vue?vue&type=script&lang=js"
export * from "./rencana_kebutuhan_darah.vue?vue&type=script&lang=js"
import style0 from "./rencana_kebutuhan_darah.vue?vue&type=style&index=0&id=645cf32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cf32a",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QBtn,QTooltip,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QBtn,QTooltip,QSeparator})
